import React from 'react';

import {TypeLoc, TypeMap, TypeSat} from 'topmeteo/general/constants';

import {
    getNextImage,
    getNextOffset,
    getNextProduct,
    getPreviousImage,
    getPreviousOffset,
    getPreviousProduct,
} from 'topmeteo/general/selectors';

import {changeProduct} from 'topmeteo/base-image/actionCreators';

import BaseArrow from './BaseArrow';

const PreviousDate = {key: 'Left', action: getPreviousOffset};
const PreviousIndex = {key: 'Left', action: getPreviousImage};
const PreviousProduct = {key: 'Up', action: getPreviousProduct, change: changeProduct};
const NextIndex = {key: 'Right', action: getNextImage};
const NextDate = {key: 'Right', action: getNextOffset};
const NextProduct = {key: 'Down', action: getNextProduct, change: changeProduct};

const Directions = {
    [TypeMap]: [
        PreviousProduct,
        PreviousIndex,
        NextIndex,
        NextProduct,
    ],
    [TypeSat]: [
        PreviousProduct,
        PreviousIndex,
        NextIndex,
        NextProduct,
    ],
    [TypeLoc]: [
        PreviousDate,
        NextDate,
    ],
};

const Arrows = ({type}) => (Directions[type] || []).map(arrow => <BaseArrow {...arrow} direction={arrow.key} />);

export default Arrows;
